import React from "react";
import { TablePagination, IconButton } from "@material-ui/core";
import { Refresh, Warning, Block } from "@material-ui/icons";
import { red, yellow } from "@material-ui/core/colors";
import dayjs from "dayjs";
const TablePaginationActions = React.lazy(() => import("./TablePagination"));
const WhiteListedDevicesTable = ({
    handleChangePage,
    handleChangeRowsPerPage,
    rowsPerPage,
    page,
    data,
    getWhiteListedDevices,
    handleSearch,
    handleOpen,
    handleDelete
}) => {
    return (
        <div className="row">
            <div className="col">
                <div className="card">
                    <div className="card-header pb-0">
                        <div className="row my-3 align-items-center">
                            {/* Left Section: Refresh Button and Filter Dropdown */}
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-8 d-flex align-items-center">
                                {/* Refresh Button */}
                                <IconButton
                                    color="primary"
                                    aria-label="room control"
                                    onClick={getWhiteListedDevices}
                                    component="span"
                                    className="me-3"
                                >
                                    <Refresh />
                                </IconButton>
                                <button
                                    type="button"
                                    className="btn waves-effect waves-light btn-danger btn-sm float-left"
                                    onClick={handleOpen}
                                >
                                    <i className="fa fa-plus"></i>
                                    <span className="icon_margin">New</span>
                                </button>
                            </div>

                            {/* Right Section: Search Bar */}
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 mt-3 mt-md-0">
                                <form>
                                    <div className="input-group border rounded-pill p-1">
                                        <div className="input-group-prepend border-0">
                                            <button
                                                type="button"
                                                className="btn btn-link text-decoration-none text-danger"
                                                id="button-addon4"
                                            >
                                                <i className="fas fa-search"></i>
                                            </button>
                                        </div>
                                        <input
                                            type="search"
                                            placeholder="What're you searching for?"
                                            aria-describedby="button-addon4"
                                            className="form-control border-0 bg-transparent rounded-pill"
                                            onChange={handleSearch}
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="card-body card-overflow">
                        <table className="table" style={{ borderCollapse: "collapse" }}>
                            <thead className="text-center">
                                <tr>
                                    <th>No</th>
                                    <th>Device ID</th>
                                    <th>Accounts</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody className="text-center">
                                {data?.length > 0 ? (
                                    (rowsPerPage > 0
                                        ? data.slice(
                                            page * rowsPerPage,
                                            page * rowsPerPage + rowsPerPage
                                        )
                                        : data
                                    ).map((_data, index) => {
                                        return (
                                            <>
                                                <tr key={index}
                                                >
                                                    <td>{index + 1}</td>
                                                    <td>{_data?.deviceId || ""}</td>

                                                    <td
                                                        data-toggle="collapse"
                                                        data-target={`#demo${index}`}
                                                        className="accordion-toggle pointer-cursor" id="btnInfo"
                                                    >
                                                        <i className="fas fa-info-circle fa-lg"></i>
                                                    </td>
                                                    <td className="pointer-cursor">
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            <span className="text-danger" onClick={() => handleOpen(_data)}>Edit</span>
                                                            <span className="text-danger-2 mt-2" onClick={() => handleDelete(_data._id)} >Delete</span>

                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="8" className="hiddenRow">
                                                        <div
                                                            id={`demo${index}`}
                                                            className="accordian-body collapse"
                                                        >
                                                            <h6 className="text-danger">
                                                                Logged-in Accounts
                                                            </h6>
                                                            <table className="w-100">
                                                                <thead>
                                                                    <tr>
                                                                        <th>No</th>
                                                                        <th>Image</th>
                                                                        <th>Username</th>
                                                                        <th>VibeLynk ID</th>
                                                                        <th>IP Address</th>
                                                                        <th>Diamonds</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody
                                                                    style={{
                                                                        maxHeight: 100,
                                                                        overflowY: "auto",
                                                                    }}
                                                                >
                                                                    {_data?.users?.length > 0 ? (
                                                                        _data.users.map((user, no) => {
                                                                            return (
                                                                                <tr key={no}>
                                                                                    <td>{no + 1}</td>
                                                                                    <td>
                                                                                        <img
                                                                                            height="50px"
                                                                                            width="50px"
                                                                                            alt="app"
                                                                                            className="mx-auto"
                                                                                            src={user?.image}
                                                                                            style={{
                                                                                                boxShadow:
                                                                                                    "0 5px 15px 0 rgb(105 103 103 / 0%)",
                                                                                                border: "2px solid #fff",
                                                                                                borderRadius: 10,
                                                                                                objectFit: "cover",
                                                                                                display: "block",
                                                                                            }}
                                                                                            onerror='this.src=,`${baseURL}storage/male.png`"'
                                                                                        />
                                                                                    </td>

                                                                                    <td>
                                                                                        {user?.name}
                                                                                    </td>
                                                                                    <td>
                                                                                        {user?.uniqueId}
                                                                                    </td>
                                                                                    <td>
                                                                                        {user?.ip}
                                                                                    </td>
                                                                                    <td>
                                                                                        {user?.diamond}
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan="7" align="center">
                                                                                Nothing to show!!
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="7" align="center">
                                            Nothing to show!!
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <TablePagination
                            id="pagination2"
                            component="div"
                            rowsPerPageOptions={[5, 10, 25, 100, { label: "All", value: -1 }]}
                            count={data?.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            SelectProps={{
                                inputProps: { "aria-label": "rows per page" },
                                native: true,
                            }}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhiteListedDevicesTable;